import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  type,
  vehicle,
  status,
  paymentType,
  customerName,
  area,
  address,
  totalWeight,
  deliveryFee,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    orderNumber,
    type,
    vehicle,
    orderDate,
    status,
    paymentType,
    customerName,
    area,
    address,
    totalWeight,
    hub: {
      name: 'สาขา',
      width: '6rem',
      filter: (val: any) => val?.name || '',
    },
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '8rem',
      class: 'text-center',
    },
    deliveryFee,
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable,
};
